import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import styles from "./Periodos.module.css";
import History from "../../components/history";
import { Table, Button, Badge, Modal } from "react-bootstrap";
import PeriodoModal from "./PeriodoModal";
import PeriodoDetalleModal from "./PeriodoDetalleModal/PeriodoDetalleModal";
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { checkSession, isMobile } from "../../core/session";
import Notifications, { notify } from "react-notify-toast";

import { FaRegEye, FaLock } from "react-icons/fa";


const Periodos = (props) => {

    const loadingBtn = require("../../assets/loaders/btn-loading.gif");

    const [cookie] = useCookies(['kUserSession']);
    const [loading, setLoading] = useState(false);
    const [periodos, setPeriodos] = useState([]);
    const [showModal, setModalVisibility] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [selectedPeriodo, setSelectedPeriodo] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [periodoToClose, setPeriodoToClose] = useState(null);
    const [closing, setClosing] = useState(false);

    const history = [
        {
            name: "Inicio",
            path: "/"
        }
    ];

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    };

    const retrievePeriodos = () => {
        setLoading(true);
        const currentFarm = cookie.kUserSession.data["farm"];
        const url = `periodos?id_estancia=${currentFarm.id}`;
        axios.get(process.env.REACT_APP_API_URL + url, prepareHeaders())
        .then(rs => {
            if(rs.status === 200){
                setPeriodos(rs.data);
            } else {
                setPeriodos([]);
            }
            setLoading(false);
        })
        .catch(error => {
            console.error(error);
            setPeriodos([]);
            setLoading(false);
        });
    };

    const handleClosePeriodo = () => {
        if(!periodoToClose) return;
        const currentFarm = cookie.kUserSession.data["farm"];
        const anho = periodoToClose.anho || periodoToClose.anio;
        const url = `periodos/${anho}/${currentFarm.id}/close`;
        setClosing(true);
        axios.put(process.env.REACT_APP_API_URL + url, {}, prepareHeaders()).then(rs => {
            setClosing(false);
            setShowConfirm(false);
            notify.show("Periodo cerrado correctamente", "success");
            retrievePeriodos();
        }).catch(error => {
            console.error(error);
            setClosing(false);
            setShowConfirm(false);
            notify.show("Ha ocurrido un error al cerrar el periodo", "error");
        });
    };

    useEffect(() => {
        checkSession("home", props.history, cookie.kUserSession);
        retrievePeriodos();
    }, []);

    return (
        <>
            <Notifications />
            <PeriodoModal show={showModal} handleClose={() => { setModalVisibility(false); }} callback={retrievePeriodos} />
            <PeriodoDetalleModal show={showDetail} handleClose={() => { setShowDetail(false); }} periodo={selectedPeriodo} />
            <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>Confirmar</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Está seguro que desea cerrar el periodo?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirm(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={handleClosePeriodo}>
                        { closing ? <img src={loadingBtn} height="15"/> : <span>Confirmar</span> }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Header history={props.history} />
            <section className={styles.body}>
                <History items={history} current={"Periodos"} history={props.history} />
                <section className={styles.content}>
                    <h1 className={styles.title}>Gestión de periodos</h1>
                    <section className={styles.actions}>
                        <Button className={`karanda-btn ${styles.btnRegister}`} onClick={() => { setModalVisibility(true); }}>Registrar periodo</Button>
                        {
                            loading ? <div style={{marginTop: "15px", textAlign: "center"}}><img src={loadingBtn} height="50"  /> </div> : (
                                periodos.length === 0 ? (
                                    <div style={{marginTop: "15px", textAlign: "center"}}><span>No hay resultados</span></div>
                                ) : (
                                    isMobile() ? (
                                        periodos.map((i) => (<></>))
                                    ) : (
                                        <Table className="karanda-table" style={{ marginTop: "15px" }}>
                                            <thead>
                                                <tr>
                                                    <th>Año</th>
                                                    <th>Fecha inicio</th>
                                                    <th>Fecha fin</th>
                                                    <th>Estado</th>
                                                    <th>Fecha creación</th>
                                                    <th>Creado por</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    periodos.map((p, idx) => (
                                                        <tr key={idx}>
                                                            <td>{p.anho || p.anio}</td>
                                                            <td>{p.fecha_inicio || p.fechaInicio}</td>
                                                            <td>{p.fecha_fin || p.fechaFin}</td>
                                                            <td><Badge className={p.estado === 'CERRADO' ? 'badge-cerrado' : 'badge-abierto'}>{p.estado}</Badge></td>
                                                            <td>{p.fecha_creacion || p.fechaCreacion}</td>
                                                            <td>{p.usuario_creacion ? `${p.usuario_creacion.nombres} ${p.usuario_creacion.apellidos}` : p.usuarioCreacion ? `${p.usuarioCreacion.nombres} ${p.usuarioCreacion.apellidos}` : ''}</td>
                                                            <td style={{ display: "flex", textAlign: "center" }}>
                                                                <Button style={{ display: "flex", alignItems: "center", gap: "0.4rem" }} size="sm" className="karanda-btn" onClick={() => { setSelectedPeriodo(p); setShowDetail(true); }}><FaRegEye/> Ver detalle</Button>
                                                                { p.estado !== 'CERRADO' && (
                                                                    <Button style={{ display: "flex", alignItems: "center", gap: "0.4rem", marginLeft: "5px" }} size="sm" className="karanda-btn" onClick={() => { setPeriodoToClose(p); setShowConfirm(true); }}><FaLock/> Cerrar periodo</Button>
                                                                ) }
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    )
                                )
                            )
                        }
                    </section>
                </section>
            </section>
        </>
    );

};

export default Periodos;
